let videoStore = {};

export function set(_videos) {
    videoStore = _videos;
}

export function get() {
    return videoStore;
}
